(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bzh-case-details"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bzh-case-details')) {
  customElements.define('bzh-case-details', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      let opener;
      this.addEventListener('click', (event) => {
        const dimensionsLink = event.target.closest('[data-bzh-case-dimensions]');
        if (dimensionsLink && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
          const details = this.querySelector('.bzh-case-details__dimensions');
          if (details) {
            event.preventDefault();
            details.open = true;
            details.scrollIntoView({behavior: 'auto', block: 'start'});
            details.querySelector('summary').focus({preventScroll: true});
          }
        }
        if (!dialog || typeof dialog.showModal !== 'function') return;
        const link = event.target.closest('[data-bzh-case-zoom]');
        if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
          event.preventDefault();
          opener = link;
          const source = link.querySelector('img');
          const picture = new Image();
          picture.src = link.href;
          picture.alt = source?.alt || '';
          if (source) { picture.width = source.width; picture.height = source.height; }
          dialog.querySelector('[data-bzh-case-full-image]').replaceChildren(picture);
          if (!dialog.open) dialog.showModal();
        }
        if (event.target.closest('[data-bzh-case-close]')) dialog.close();
        if (event.target === dialog) {
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }
      });
      dialog?.addEventListener('close', () => { if (opener?.isConnected) opener.focus(); });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bzh-light-details"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bzh-light-details')) {
  customElements.define('bzh-light-details', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      let opener;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-bzh-zoom]');
        if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
          event.preventDefault();
          opener = link;
          const source = link.querySelector('img');
          const picture = new Image();
          picture.src = link.href;
          picture.alt = source?.alt || link.dataset.bzhPhotoAlt || '';
          if (source) { picture.width = source.width; picture.height = source.height; }
          dialog.querySelector('[data-bzh-full-image]').replaceChildren(picture);
          if (!dialog.open) dialog.showModal();
        }
        if (event.target.closest('[data-bzh-close]')) dialog.close();
        if (event.target === dialog) {
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }
      });
      dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus(); });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
